import React from 'react'
import { useTranslation } from 'react-i18next'

import { Divider } from 'primereact/divider'

import { PanelContainer } from '../../../../../components/Panel'
import { CompanyCodesData } from './company-codes'
import { SupplierData } from './supplier'

export const AdditionalProperties: React.FC = () => {
  const { t } = useTranslation()

  return (
    <PanelContainer
      header={t('buyerSettings.additionalProperties.title')}
      id="settings-additional-properties"
      toggleable={false}
    >
      <div className="grid">
        <CompanyCodesData />

        <div className="col-12">
          <Divider />
        </div>

        <SupplierData />
      </div>
    </PanelContainer>
  )
}
